var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: { "no-data-text": "No tienes destinatarios", data: _vm.subjects },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(subject, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: subject } },
                [
                  _c("vs-td", { attrs: { data: subject.subjectType.label } }, [
                    _vm._v(" " + _vm._s(subject.subjectType.label) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: subject.subject.label } }, [
                    _vm._v(" " + _vm._s(subject.subject.label) + " ")
                  ]),
                  subject.subjectTypeDigitalDoc.label
                    ? _c(
                        "vs-td",
                        {
                          attrs: { data: subject.subjectTypeDigitalDoc.label }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(subject.subjectTypeDigitalDoc.label) +
                              " "
                          ),
                          _c("small", { staticClass: "d-block" }, [
                            _vm._v("institución")
                          ])
                        ]
                      )
                    : _vm._e(),
                  subject.providence
                    ? _c("vs-td", { attrs: { data: subject.providence } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.providencesMap[subject.providence]) +
                            " "
                        ),
                        subject.providenceExpiration
                          ? _c("span", [
                              _vm._v(
                                " - " +
                                  _vm._s(subject.providenceExpiration) +
                                  " "
                              )
                            ])
                          : _vm._e(),
                        _c("small", { staticClass: "d-block" }, [
                          _vm._v("providencia")
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            })
          }
        }
      ])
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Destino")]),
          _c("vs-th", [_vm._v("Lista Destino")]),
          _c("vs-th", [_vm._v("Extra")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }